import { ManagersModuleBase } from "Managers/ManagersModuleBase";
import { StudentSessionReportViewModel } from "../StudentSessionReportViewModel";
import { CommandsManager } from "./CommandsManager";
import { MobXManager } from "./MobXManager";
import { APIManager } from "./APIManager";
import { DomainManager } from "./DomainManager";
import { StudentSessionReportManagersConfig } from "../Interfaces/IStudentSessionReportViewModel";
import { AppUrls } from "AppUrls";

/** Default config for Admin/StudentReports flow */
const SESSION_REPORT_CONFIG: StudentSessionReportManagersConfig = {
    getNavigationConfirmPath: (vm) => AppUrls.Client.Students.Student.StudentReports.Edit.replace(":id", vm.model.studentId ?? vm.model.student.id ?? ""),
    getCancelPath: (vm) => AppUrls.Client.Students.Student.StudentReports.Edit.replace(":id", vm.model.studentId ?? vm.model.student.id ?? ""),
    isAdmin: true,
    showExport: true,
};

/**
 * Orchestrates all manager instances for SessionReportViewModel.
 * Provides centralized access to command, API, state, and domain managers.
 */
export class ManagersModule extends ManagersModuleBase<StudentSessionReportViewModel> {
    public commands!: CommandsManager;
    public mobx!: MobXManager;
    public api!: APIManager;
    public domain!: DomainManager;
    public config: StudentSessionReportManagersConfig;

    constructor(viewModel: StudentSessionReportViewModel, config?: Partial<StudentSessionReportManagersConfig>) {
        super(viewModel);
        this.config = { ...SESSION_REPORT_CONFIG, ...config };
        this.createManagers();
    }

    protected createManagers(): void {
        this.mobx = new MobXManager(this.viewModel);
        this.domain = new DomainManager(this.viewModel, this.config);
        this.api = new APIManager(this.viewModel);
        this.commands = new CommandsManager(this.viewModel, this.config);
    }
}
